const constants = {
    SIDEBAR: {
        EVIDENCE_TITLE: "EvidenceTitle",
        HISTORY_TITLE: "HistoryTitle"
    }
};

export { constants as FOCUS_CONSTANTS };
